module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[94]459.077edb7.woff2";